import React, { Component } from "react";
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";

class GoogleMapContainer extends Component {
  render() {
    return (
      <GoogleMap
        options={this.props.options}
        defaultZoom={this.props.zoom}
        defaultCenter={this.props.center}
      >
        {this.props.children}
      </GoogleMap>
    );
  }
}

export default withScriptjs(withGoogleMap(GoogleMapContainer));



// WEBPACK FOOTER //
// ./src/utils/GoogleMapContainer.js